// Modal
import React, { PropsWithChildren } from 'react';
import styles from './Modal.module.sass';
import cn from 'classnames';

export interface ModalProps extends PropsWithChildren {
  open: boolean;
  onBackdropClick: () => void;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onBackdropClick,
  className,
  children,
}) => {
  return (
    <div
      style={open ? {} : { display: 'none' }}
      className={cn(styles.modal, className)}
      onClick={onBackdropClick}
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
};

export default Modal;
